import { Component } from '@angular/core';

@Component({
  selector: 'app-signout-callback',
  template: `<p>Signing you out...</p>`
})
export class SignoutCallbackComponent {}
